import { render, staticRenderFns } from "./ExportCode.vue?vue&type=template&id=08becbb3&scoped=true&"
import script from "./ExportCode.vue?vue&type=script&lang=js&"
export * from "./ExportCode.vue?vue&type=script&lang=js&"
import style0 from "./ExportCode.vue?vue&type=style&index=0&id=08becbb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08becbb3",
  null
  
)

export default component.exports